import { dynamic, literal } from 'superstruct';

import { getFieldParentObject } from './getFieldParentObject';
import { withMessage } from './withMessage';

export const matchesField = <T>(field: string, message?: string) =>
	dynamic<T>((_value, { branch }) => {
		const parent = getFieldParentObject(branch);

		const match = parent[field];
		const type = literal<T>(match as T);
		if (message) {
			return withMessage(type, message);
		} else {
			return type;
		}
	});
